import React from 'react'
import { isEmpty } from 'ramda'
import { Link } from 'react-router-dom'
import { Alert, Row, Col } from 'reactstrap'

const NoProductFounds = ({ search = '', categoryId = '' }) => {
  const mailtoString = `mailto:support@dealmed.com?
    subject=Issue%20searching%20items%20on%20website&body=SearchTerm%3A%20${search}%0ACategory%3A%20${categoryId}
    %0A%0AWhen%20searching%20the%20website%20for%20products%20i%20encountered%20%22no%20products%20found%22%20with%20the%20above%20query%0A#####Type an addidtional message below this line#####%0A%0A`

  const renderNoCategoryFound = () => [
    <li key="1">Try a different category</li>,
    <li key="2">Use the search bar to find products</li>,
  ]

  const renderProductsFound = () => [
    <li key="1">Check your spelling</li>,
    <li key="2">Use different keywords and try again</li>,
    <li key="3">
      {'Try'}
      <Link to="/shop" className="text-primary">
        {' '}
        searching by category
      </Link>
    </li>,
  ]
  return (
    <Row className="no-products-found">
      <Col className="d-flex justify-content-center">
        <Alert className="d-flex justify-content-center">
          <div className="mt-3">
            <h4>{`Sorry, no products matched ${
              categoryId ? 'this category' : '"' + search.substring(0, 50) + '"'
            }`}</h4>
            <ul className="mt-5">
              {categoryId || (isEmpty(categoryId) && !search)
                ? renderNoCategoryFound()
                : renderProductsFound()}
              <li>
                <a className="text-primary" href={mailtoString}>
                  Email Us,{' '}
                </a>
                <Link to="/contactus" className="text-primary">
                  Go to contact page
                </Link>
              </li>
            </ul>
          </div>
        </Alert>
      </Col>
    </Row>
  )
}

export default NoProductFounds
